export const BW_SEMANTIC_ROLE_KEYS = [
  "surface",
  "onSurface",
  "primary",
  "onPrimary",
  "selected",
  "onSelected",
  "focus",
  "pending",
  "success",
  "warning",
  "error",
  "conflict",
  "live",
] as const;

export type BwSemanticRoleKey = (typeof BW_SEMANTIC_ROLE_KEYS)[number];

export type BwSemanticRoles = Record<BwSemanticRoleKey, string>;

export const BW_LIGHT_SEMANTIC_ROLES: Readonly<BwSemanticRoles> = {
  surface: "#ffffff",
  onSurface: "#172018",
  primary: "#176b45",
  onPrimary: "#ffffff",
  selected: "#d7f5e5",
  onSelected: "#0b4d31",
  focus: "#075fce",
  pending: "#9a5a00",
  success: "#08783f",
  warning: "#9a5a00",
  error: "#b3261e",
  conflict: "#8b3d8f",
  live: "#b42318",
};

export const BW_DARK_SEMANTIC_ROLES: Readonly<BwSemanticRoles> = {
  surface: "#111512",
  onSurface: "#e8eee9",
  primary: "#7bdfa9",
  onPrimary: "#003920",
  selected: "#174d34",
  onSelected: "#b8f3d3",
  focus: "#9bcaff",
  pending: "#ffb95c",
  success: "#72dc9e",
  warning: "#ffb95c",
  error: "#ffb4ab",
  conflict: "#efb3f2",
  live: "#ffb4ab",
};
